import {json, texture, MiniSignal} from "p3";
import common from "../common";
import definitions from "../definitions";
import QuestFactory from "../game/quest/QuestFactory";
import ScrollBar from "../ui/ScrollBar";
import TextFormat from "../ui/TextFormat";
import {locale} from "../utils";
import GameScene from "./GameScene";
import MenuScene from "./MenuScene";
import Scene from "./Scene";

export default class QuestScene extends MenuScene {
    constructor(questLog) {
        super("quest");

        this._questLog = questLog;

        this._menuHolder = null;
        this._menuBacking = null;
        this._menuContent = null;
        this._menuMask = null;
        this._bottomScroll = null;
        this._scrollbarRope = null;
        this._scrollbar = null;

        this.signals.locationJump = new MiniSignal();
    }

    init() {
        super.init(); 
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        //console.log(this._questLog);

        this.interactive = true;

        if (!common.saveData.settings.musicMute) {
            P3.audio.playMusic("music_map_loop");
        }
        P3.audio.playSound("vo_bert_hahum_00");

        this.createFill();
        this.createTitleBanner(locale('ui_quests_title'));

        this._menuHolder = new PIXI.Container();
        this._menuHolder.x = common.STAGE_WIDTH/2;
        this._menuHolder.y = 150;
        this.addChild(this._menuHolder);

        this._menuBacking = new PIXI.TilingSprite(texture('quest_panel_tile'), 590, 30);
        this._menuBacking.anchor.x = 0.5;
        this._menuBacking.y = 30;
        this._menuHolder.addChild(this._menuBacking);

        let menuContentHolder = new PIXI.Container();
        menuContentHolder.y = this._menuBacking.y + 30;
        this._menuHolder.addChild(menuContentHolder);

        this._menuContent = new PIXI.Container();
        menuContentHolder.addChild(this._menuContent);

        this._menuMask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._menuMask.tint = 0x000000;
        this._menuMask.anchor.x = 0.5;
        this._menuMask.y = this._menuBacking.y;
        this._menuMask.width = this._menuBacking.width;
        this._menuMask.height = this._menuBacking.height;
        menuContentHolder.mask = this._menuMask;
        this._menuHolder.addChild(this._menuMask);

        let topScroll = new PIXI.Sprite(texture('quest_panel_edge'));
        topScroll.anchor.x = 0.5;
        this._menuHolder.addChild(topScroll);

        this._bottomScroll = new PIXI.Sprite(texture('quest_panel_edge'));
        this._bottomScroll.anchor.set(0.5);
        this._bottomScroll.y = this._menuBacking.y + this._menuBacking.height + 37;
        this._menuHolder.addChild(this._bottomScroll);

        this._scrollbarRope = new PIXI.NineSlicePlane(P3.assets.texture('scroll_rope'), 10, 25, 10, 25);
        this._scrollbarRope.x = (topScroll.width/2) - 55;
        this._scrollbarRope.y = 10;
        this._scrollbarRope.height = this._menuBacking.height + 50;
        this._menuHolder.addChild(this._scrollbarRope);  

        this._closeButton = this.addCloseButton(this._menuHolder.x + (this._menuHolder.width/2), this._menuHolder.y);
        this._closeButton.overSoundName = "sfx_btn_generic_rollover";
        this._closeButton.clickSoundName = "sfx_btn_quests_close";

        this.fillQuestList();

        this.resize();

        this.animateShow();
    }

    destroy() {
        this._closeButton.destroy();

        P3.audio.stopMusic();

        super.destroy();
    }

    update() {
        super.update();

        if(this._scrollbar){
            this._scrollbar.update();
            //this._menuContent.y = this._menuBacking.y + 30 + ((-this._menuContent.height + this._menuMask.height + 100) * this._scrollbar.value);
            this._menuContent.y = -(this._menuContent.height-this._menuMask.height+50) * this._scrollbar.value;
        }
    }

    fillQuestList() {

        let list = this._questLog.getActiveQuests();
        const activeQuestsLength = list.length;
        list = list.concat(this._questLog.getCompleteQuests());

        let currentY = 10;
        for(let i = 0; i < list.length; i++){

            const npcData = json(list[i].owner);
            console.log(list[i]);
            console.log(npcData);

            if (QuestFactory.isMinigame(npcData.quests[list[i].id].type) ||
                QuestFactory.isBossFight(npcData.quests[list[i].id].type)) {
                continue;
            }

            const item = new PIXI.Container();
            item.y = currentY;
            this._menuContent.addChild(item);

            const complete = i >= activeQuestsLength;

            const itemFrame = new PIXI.NineSlicePlane(texture(complete ? 'quest_frame_complete_9slice' : 'quest_frame_9slice'), 25, 25, 25, 25);
            itemFrame.width = 500;
            itemFrame.x = -itemFrame.width/2;
            item.addChild(itemFrame);

            const npcIcon = new PIXI.Sprite(texture(npcData.quests[list[i].id].avatar || npcData.character.avatar));
            npcIcon.x = -244;
            npcIcon.y = -10;
            item.addChild(npcIcon);

            const npcMargin = 0;

            const titleLabel = new PIXI.BitmapText(locale(list[i].name).toUpperCase(), {
                fontName: "Alghera Pro",
                fontSize: 28,
                align: "left",
                tint: 0x000000,
                maxWidth: 260
            });
            titleLabel.x = npcIcon.x + npcIcon.width + npcMargin;
            titleLabel.y = 18;
            item.addChild(titleLabel);

            const descriptionLabel = new PIXI.BitmapText(TextFormat.formatTextVar(locale(list[i].description), definitions.TEXT_FORMAT_VAR.TARGET, list[i].target), {
                fontName: "Alghera Pro",
                fontSize: 26,
                align: "left",
                tint: 0x702311,
                maxWidth: 250
            });
            descriptionLabel.x = npcIcon.x + npcIcon.width + npcMargin;
            descriptionLabel.y = titleLabel.y + titleLabel.height + 10;
            item.addChild(descriptionLabel);

            const margins = {left:6, right:5, top:4, bottom:4};

            const barFrame = new PIXI.Sprite(texture('progress_bar_frame'));
            barFrame.x = npcIcon.x + npcIcon.width + npcMargin - margins.left;
            barFrame.y = Math.max(94, descriptionLabel.y + descriptionLabel.height + 6);
            barFrame.scale.set(0.8);
            
            const barFill = new PIXI.Sprite(PIXI.Texture.WHITE);
            barFill.tint = 0x4bb6b5;
            barFill.x = barFrame.x + margins.left;
            barFill.y = barFrame.y + margins.top;
            barFill.width = ((barFrame.width - margins.left - margins.right) * (complete ? 1 : list[i].progress));
            barFill.height = barFrame.height - margins.top - margins.bottom;
            item.addChild(barFill);

            item.addChild(barFrame);

            if (list[i].target > 1) {
                const progressLabel = new PIXI.BitmapText(String(complete ? list[i].target : list[i].value) + '/' + String(list[i].target), {
                    fontName: "Alghera Pro",
                    fontSize: 26,
                    align: "left",
                    tint: 0x702311,
                    maxWidth: 250
                });
                progressLabel.anchor.set(0, 0.5);
                progressLabel.x = barFrame.x + barFrame.width + 5;
                progressLabel.y = barFrame.y + (barFrame.height/2);
                item.addChild(progressLabel);
            }

            if (npcData.character.location && json(npcData.character.location) && json(npcData.character.location).icon) {

                const mapIcon = P3.Button.create(
                    texture('btn_quest_location_bg'),
                    texture('btn_quest_location_bg'),
                    texture('btn_quest_location_bg'),
                    texture(json(npcData.character.location).icon)
                );
                mapIcon.animateIcon = false;
                mapIcon.x = 240 - mapIcon.width/2;
                mapIcon.y = mapIcon.height/2;
                mapIcon.signals.click.once(() => {
                    P3.audio.playSound("vo_bert_huh_00");
                    this.signals.locationJump.dispatch(npcData.character.location);
                }, this);
                item.addChild(mapIcon);
            }

            if (complete) {
                const stamp = new PIXI.Sprite(texture('icon_quest_complete'));
                stamp.anchor.set(1, 0.5);
                stamp.scale.set(0.5);
                stamp.x = barFrame.x + barFrame.width;
                stamp.y = barFrame.y + (barFrame.height/2);
                item.addChild(stamp);
            }

            const barIcon = new PIXI.Sprite(texture(list[i].icon));
            barIcon.anchor.set(0.5);
            barIcon.x = barFrame.x - 10;
            barIcon.y = barFrame.y + (barFrame.height/2);
            item.addChild(barIcon);

            currentY += item.height + 10;
            itemFrame.height = item.height;
        }
    }

    animateShow(){
        this.animateTitleBannerIn();

        this._closeButton.scale.set(0);
        this._closeButton.interactive = false;

        GameScene.active.addTween(gsap.to(this._menuHolder, 0.4, {delay:0.2, y:this._menuHolder.y, ease:Expo.easeOut, onComplete:() => {
            
            const scrollHeight = 500;
            GameScene.active.addTween(gsap.to(this._menuBacking, 0.7, {height:scrollHeight, ease:Expo.easeOut, onComplete:() => {
                this.animateCloseButtonIn();
                this.animateShowFinished();
            }, onUpdate:() => {
                this._menuMask.height = this._menuBacking.height;
                this._scrollbarRope.height = this._menuBacking.height + 50;
            }}));
            GameScene.active.addTween(gsap.to(this._bottomScroll, 0.7, {y:this._bottomScroll.y + (scrollHeight - this._menuBacking.height), ease:Expo.easeOut}));

        }}));
        this._menuHolder.y = common.STAGE_HEIGHT + 100;
    }

    animateHide(){
        this.animateFillOut();
        this.animateTitleBannerOut();

        this._closeButton.interactive = false;
        GameScene.active.addTween(gsap.to(this._closeButton.scale, 0.3, {x:0, y:0, ease:Sine.easeIn}));

        if(this._scrollbar){
            this._menuHolder.removeChild(this._scrollbar);
            this._scrollbar.destroy();
        }

        GameScene.active.addTween(gsap.to(this._menuBacking, 0.3, {height:30, ease:Expo.easeOut, onComplete:() => {
            GameScene.active.addTween(gsap.to(this._menuHolder, 0.4, {y:common.STAGE_HEIGHT + 100, ease:Sine.easeIn, onComplete:() => {
                this.signals.previous.dispatch();
            }}));
        }, onUpdate:() => {
            this._menuMask.height = this._menuBacking.height;
            this._scrollbarRope.height = this._menuBacking.height + 50;
        }}));
        GameScene.active.addTween(gsap.to(this._bottomScroll, 0.3, {y:this._menuBacking.y + 67, ease:Expo.easeOut}));

    }

    animateShowFinished()
    {
        if(this._menuContent.height < this._menuMask.height)
            return;

        this._scrollbar = new ScrollBar(texture('scroll_slider'), 310);
        this._scrollbar.y = this._scrollbarRope.y + (this._scrollbar.height/2) - 10;
        this._scrollbar.x = this._scrollbarRope.x - (this._scrollbar.width/2) + 14;
        this._menuHolder.addChild(this._scrollbar);
        this._scrollbar.init();
    }
}

/**
 * @static
 * @type {QuestScene}
 */
QuestScene.active = null;